(function () {
    'use strict';

    function initBrandsMegaMenu(menu) {
        if (!menu || menu.dataset.brandsInitialized === 'true') {
            return;
        }

        const scroller = menu.querySelector('.js-brands-scroller');
        const previousButton = menu.querySelector('.js-brands-previous');
        const nextButton = menu.querySelector('.js-brands-next');
        const letterButtons = Array.from(
            menu.querySelectorAll('.brands-mega-menu__letter:not(:disabled)')
        );
        const groups = Array.from(
            menu.querySelectorAll('.brands-mega-menu__group')
        );

        if (!scroller || !groups.length) {
            return;
        }

        menu.dataset.brandsInitialized = 'true';

        function setActiveLetter(targetId) {
            letterButtons.forEach(function (button) {
                const isActive = button.dataset.brandTarget === targetId;

                button.classList.toggle('is-active', isActive);
                button.setAttribute(
                    'aria-pressed',
                    isActive ? 'true' : 'false'
                );
            });
        }

        function scrollToGroup(targetId) {
            const target = menu.querySelector(
                '#' + CSS.escape(targetId)
            );

            if (!target) {
                return;
            }

            const leftPosition =
                target.offsetLeft - scroller.offsetLeft - 12;

            scroller.scrollTo({
                left: Math.max(0, leftPosition),
                behavior: 'smooth'
            });

            setActiveLetter(targetId);
        }

        letterButtons.forEach(function (button) {
            button.setAttribute(
                'aria-pressed',
                button.classList.contains('is-active')
                    ? 'true'
                    : 'false'
            );

            button.addEventListener('click', function () {
                const targetId = button.dataset.brandTarget;

                if (targetId) {
                    scrollToGroup(targetId);
                }
            });
        });

        if (previousButton) {
            previousButton.addEventListener('click', function () {
                scroller.scrollBy({
                    left: -(scroller.clientWidth * 0.75),
                    behavior: 'smooth'
                });
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', function () {
                scroller.scrollBy({
                    left: scroller.clientWidth * 0.75,
                    behavior: 'smooth'
                });
            });
        }

        let scrollFrame;

        scroller.addEventListener(
            'scroll',
            function () {
                if (scrollFrame) {
                    window.cancelAnimationFrame(scrollFrame);
                }

                scrollFrame = window.requestAnimationFrame(function () {
                    const scrollerBox = scroller.getBoundingClientRect();
                    const referencePoint =
                        scrollerBox.left + Math.min(100, scrollerBox.width * 0.2);

                    let nearestGroup = groups[0];
                    let nearestDistance = Infinity;

                    groups.forEach(function (group) {
                        const groupBox = group.getBoundingClientRect();
                        const distance = Math.abs(
                            groupBox.left - referencePoint
                        );

                        if (distance < nearestDistance) {
                            nearestDistance = distance;
                            nearestGroup = group;
                        }
                    });

                    if (nearestGroup && nearestGroup.id) {
                        setActiveLetter(nearestGroup.id);
                    }

                    updateArrowState();
                });
            },
            { passive: true }
        );

        function updateArrowState() {
            const maximumScroll =
                scroller.scrollWidth - scroller.clientWidth;
            const currentScroll = scroller.scrollLeft;

            if (previousButton) {
                const isAtStart = currentScroll <= 2;

                previousButton.disabled = isAtStart;
                previousButton.setAttribute(
                    'aria-disabled',
                    isAtStart ? 'true' : 'false'
                );
            }

            if (nextButton) {
                const isAtEnd =
                    maximumScroll <= 2 ||
                    currentScroll >= maximumScroll - 2;

                nextButton.disabled = isAtEnd;
                nextButton.setAttribute(
                    'aria-disabled',
                    isAtEnd ? 'true' : 'false'
                );
            }
        }

        updateArrowState();

        window.addEventListener('resize', updateArrowState);
    }

    function initAllBrandsMenus(root) {
        const scope = root || document;

        scope
            .querySelectorAll('.js-brands-mega-menu')
            .forEach(initBrandsMegaMenu);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAllBrandsMenus(document);
        });
    } else {
        initAllBrandsMenus(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
        initAllBrandsMenus(event.target);
    });
})();